import { render } from "./UsersListPage.vue?vue&type=template&id=735f7cdd&scoped=true"
import script from "./UsersListPage.vue?vue&type=script&lang=js"
export * from "./UsersListPage.vue?vue&type=script&lang=js"

import "./UsersListPage.vue?vue&type=style&index=0&id=735f7cdd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-735f7cdd"]])

export default __exports__